<template>
  <div class="w-screen max-w-md">
    <div class="glass-carbon flex h-full flex-col overflow-y-scroll pb-24">
      <div class="dark:bg-ontick-carbon-500 sticky top-0 z-10 bg-gray-50 px-6 py-3 pr-14">
        <div class="flex items-center space-x-4">
          <div class="h-7">
            <button @click="$emit('close')" class="py-1 text-gray-400 hover:text-gray-400 focus:outline-none">
              <span v-html="$icons.arrow_left" />
            </button>
          </div>
          <h2 class="text-ontick-carbon-900 py-3 text-lg font-semibold dark:text-gray-300">Filtros</h2>
        </div>

        <!-- <div class="w-full py-3">
          
          <div
            class="
              flex
              h-16
              flex-wrap
              items-start
              space-x-2
              overflow-y-scroll
              rounded-md
              bg-ontick-steel-100
              px-2
              py-2
              dark:bg-ontick-steel-800
            "
          ></div>
        </div> -->
      </div>

      <div class="space-y-6 px-6 py-3 pr-14">
        <div v-for="filter in getFilters" :key="filter.name" class="space-y-2">
          <span class="" v-if="filter.name !== 'Caracteres'">
            {{ filter.name }}
          </span>
          <div class="w-full">
            <ontick-slider-component
              v-if="filter.type === 'range'"
              :min="filter.min"
              :max="filter.max"
              :from="filter.from"
              :to="filter.to"
              :step="filter.step"
              :isCurrency="['sugg_capital', 'max_loss'].includes(filter.slug)"
              :percent="['profit', 'win_ratio'].includes(filter.slug)"
              :limit="limit(filter.slug)"
              @input="setRangeFilter({ name: filter.name, value: $event })"
            />
            <div class="space-y-2" v-if="['tagbox', 'select'].includes(filter.type)">
              <button
                v-for="item in filter.items"
                :key="item.value"
                class="mx-1 max-w-min cursor-pointer whitespace-nowrap rounded border px-2 py-1 text-sm first:ml-0 last:mr-0"
                :class="
                  filter.active.includes(item.value)
                    ? 'bg-ontick-blue-600 border-ontick-blue-600'
                    : 'border-gray-500 bg-transparent'
                "
                @click="setToggleFilter({ name: filter.name, value: item.value })"
              >
                {{ item.displayName }}
              </button>
            </div>
          </div>
        </div>
        <div class="pt-6" v-if="getActiveFilters.length">
          <ontick-button
            class="w-full"
            customClass="border border-ontick-blue-600 text-ontick-blue-600 rounded"
            @click.native="clearMarketplace"
          >
            Remover filtros
          </ontick-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import CollapseGroup from "@/app/shared/components/expanded/collapse.transition-group.component";
import OntickSliderComponent from "../../../../shared/components/basic/ontick-slider.component.vue";
export default {
  components: {
    CollapseTransition,
    CollapseGroup,
    OntickSliderComponent,
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      getFilters: "marketplace/getFilters",
      getActiveFilters: "marketplace/getActiveFilters",
      getSelectedAccount: "accountTypes/getSelectedAccount",
    }),
  },

  methods: {
    ...mapActions({
      getMarketplaceSearch: "marketplace/getMarketplaceSearch",
      getMarketplace: "marketplace/getMarketplace",
      setRangeFilter: "marketplace/setRangeFilter",
      setToggleFilter: "marketplace/setToggleFilter",
      clearActiveFilters: "marketplace/clearActiveFilters",
      setMarketplaceByFilters: "marketplace/setMarketplaceByFilters",
    }),

    limit(val) {
      switch (val) {
        case "sugg_capital":
          return ">=";
        case "max_loss":
          return "<=";
        case "profit":
          return ">=";
        default:
          return "=";
      }
    },

    clearMarketplace() {
      if (this.$route.name === "Analistas XP") {
        this.getMarketplace({
          account_id: this.getSelectedAccount.account_id,
          category_group: "xp",
        });
      } else {
        this.getMarketplace("reset_filter");
      }
      this.clearActiveFilters();
      this.$emit("show-ranking", true);
    },
  },

  watch: {
    getActiveFilters: {
      deep: true,
      handler(val) {
        let query = {};

        query.account_id = this.getSelectedAccount.account_id;

        // TEXT
        query.text = val
          .find((item) => item.name === "chars")
          ?.value?.normalize("NFD")
          ?.replace(/[\u0300-\u036f]/g, "");

        // CAPITAL
        query.min_capital = val.find((item) => item.name === "sugg_capital")?.from;
        query.max_capital = val.find((item) => item.name === "sugg_capital")?.to;

        // DAILY LOSS
        query.min_daily_loss = val.find((item) => item.name === "max_loss")?.from;
        query.max_daily_loss = val.find((item) => item.name === "max_loss")?.to;

        // RETURN
        query.min_perc_return = val.find((item) => item.name === "profit")?.from;
        query.max_perc_return = val.find((item) => item.name === "profit")?.to;

        // WIN RATIO
        query.min_win_ratio = val.find((item) => item.name === "win_ratio")?.from;
        query.max_win_ratio = val.find((item) => item.name === "win_ratio")?.to;

        query.markets = val.find((item) => item.name === "markets")?.value;
        query.risk = val.find((item) => item.name === "risk")?.value;
        query.plan_type = val.find((item) => item.name === "account_level")?.value.join("");
        query.timeframe = val.find((item) => item.name === "strategy_timeframe")?.value.join("");
        query.strategy_style = val.find((item) => item.name === "strategy_style")?.value.join("");

        if (Object.values(query).filter((item) => !!item).length === 1) {
          // console.log("reset");
          this.getMarketplace({
            param: "reset_filter",
            account_id: this.$route.name === "Analistas XP" ? this.getSelectedAccount.account_id : undefined,
            category_group: this.$route.name === "Analistas XP" ? "xp" : undefined,
          });
          return;
        }

        if (this.$route.name === "Analistas XP") {
          query.tag = "xp";
        }

        this.$api
          .get(this.$endpoint.GET_MARKETPLACE_SEARCH, {
            params: query,
          })
          .then((res) => {
            // console.log(res.data);
            this.setMarketplaceByFilters(res.data);
          })
          .catch((err) => {
            console.error(err.data.msg);
            if (err.data.msg === "Nenhuma estratégia encontrada") {
              this.setMarketplaceByFilters([]);
            }
          });
      },
    },
  },
};
</script>
